import { render } from "./RAMailRequest.vue?vue&type=template&id=bc195a22&scoped=true"
import script from "./RAMailRequest.vue?vue&type=script&lang=js"
export * from "./RAMailRequest.vue?vue&type=script&lang=js"

import "./RAMailRequest.vue?vue&type=style&index=0&id=bc195a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc195a22"]])

export default __exports__